import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M533.303 1778.7v-106.669H1920v106.67H533.303zm0-853.352V818.68H1920v106.67H533.303zm0 426.676V1245.25H1920v106.775H533.303zM357.66 141l304.434 304.327L357.66 749.76l-75.308-75.521L457.93 498.66H106.562V1778.69H0V392.099h457.93l-175.577-175.79L357.66 141zM853.31 498.672v-106.67h213.338v106.67H853.31zm426.676 0v-106.67h213.338v106.67h-213.338zm426.676 0v-106.67H1920v106.67h-213.338z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveUpTopLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMoveUpTopLine, _Component);

  var _super = _createSuper(IconMoveUpTopLine);

  function IconMoveUpTopLine() {
    _classCallCheck(this, IconMoveUpTopLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMoveUpTopLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMoveUpTop",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMoveUpTopLine.displayName = "IconMoveUpTopLine";
  return IconMoveUpTopLine;
}(Component);

IconMoveUpTopLine.glyphName = 'move-up-top';
IconMoveUpTopLine.variant = 'Line';
IconMoveUpTopLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMoveUpTopLine;
export { IconMoveUpTopLine };